var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9483,
    cy: 15.9483,
    r: 15.3103,
    fill: "white",
    stroke: "#2C6FC4",
    strokeWidth: 1.27586
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2143 10.2286V8.76656C19.2143 8.42753 19.3929 8.19444 19.75 8.06731C20.1071 7.94017 20.4167 7.99314 20.6786 8.22623L23.75 10.9597C23.869 11.0656 23.9405 11.1822 23.9643 11.3093C24.0119 11.4364 24.0119 11.5636 23.9643 11.6907C23.9405 11.8178 23.869 11.9344 23.75 12.0403L20.6786 14.7738C20.4167 15.0069 20.1071 15.0598 19.75 14.9327C19.3929 14.8056 19.2143 14.5725 19.2143 14.2334V12.7714H8.42857C8.14286 12.7714 8 12.6442 8 12.39V10.61C8 10.3558 8.14286 10.2286 8.42857 10.2286H19.2143Z",
    fill: "#2C6FC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7857 21.453V23.1239C12.7857 23.5114 12.6071 23.7778 12.25 23.9231C11.8929 24.0684 11.5833 24.0078 11.3214 23.7415L8.25 20.6175C8.08333 20.448 8 20.2422 8 20C8 19.7578 8.08333 19.552 8.25 19.3825L11.3214 16.2585C11.5833 15.9922 11.8929 15.9316 12.25 16.0769C12.6071 16.2222 12.7857 16.4886 12.7857 16.8761V18.547H23.5714C23.8571 18.547 24 18.6923 24 18.9829V21.0171C24 21.3077 23.8571 21.453 23.5714 21.453H12.7857Z",
    fill: "#2C6FC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIcon);
export default __webpack_public_path__ + "static/media/move-icon.4154a0fff877b3ecc32538e2cc34e616.svg";
export { ForwardRef as ReactComponent };